import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../../Content";
import BaseUrl from "../../../../utils/BaseUrl";
import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import SwalTopEnd from "../../../../utils/swal_top_end";

const url = BaseUrl();
const customStyles = {
     
        headRow: {
            style: {
                backgroundColor: '#89214d',
                color: 'white'
            }
        },
        headCells: {
            style: {
                fontSize: '16px',
                fontWeight: '600',
                textTransform: 'uppercase'
            }
        },
        cells: {
            style: {
                fontSize: '15px'
            }
        }
    
}
function AddRoleForm(){
    const navigate = useNavigate();

    const [errors,setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [error,setError] = useState();
    const [permissions,setPermissions] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [roleData,setRoleData] = useState('');

    const columns = [

        {
          name: 'PERMISSIONS',
          selector: row => row.name,
          sortable: true,
        },
    
      

    ];

    useEffect(()=>{
        fetchPermissionList();
    },[]);

    const fetchPermissionList = async ()=>{
        // setLoading(true);
        try {
            axios.get(url.base+'/permission-list',{
                headers:{
                    'Content-Type':'application/json',
                    "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                    
                },
            }).then((resp)=>{

                if(resp.status == 200){
                    setPermissions(resp.data.data);
                }
                // setLoading(false);
            })
        } catch (error) {
            // setLoading(false);
        }
    }

    const handleRowSelected = (state) => {
        // console.log(state.selectedRows);
        setSelectedRows(state.selectedRows);
    };

    const submitForm=(e)=>{
        e.preventDefault();

        const permissionTab = selectedRows.map((option)=>option.name);
        // console.log(permissionTab);
        if(roleData !="" ){
            const _formData = new FormData();
            _formData.append('name',roleData);
            _formData.append('permissions', permissionTab );
      
            console.log(_formData);
            setLoading(true);
            try {
                axios.post(url.base+'/role-store',_formData,
               {
                   headers:{
                       'Content-Type':'application/json',
                       "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                       
                   },
                   credentials:'include'
               }
               ).then((resp)=>{
                  setLoading(false);

                  SwalTopEnd({icon:"success",title:"Le rôle a été enregistré avec succès"});
      
               }).catch((error)=>{
                    console.log(error);
               })
           } catch (error) {
                setLoading(false);
               console.log(error);
           } 
        }else{
          if(roleData =="")
          {
            SwalTopEnd({icon:"error",title:"Veuillez renseigner le rôle"});
          }else if(permissionTab.length == 0){
            SwalTopEnd({icon:"error",title:"Veuillez renseigner les permissions"});
          }
        }
    }
    return (
        <>
            <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Formulaire de création d'un rôle</p>
                  </a>
                </div>
                {/* <button type="button" class="btn btn-primary mt-2 mt-sm-0 btn-icon-text">
                  <i class="mdi mdi-plus-circle"></i> Add Prodcut </button> */}
              </div>
              <div class="header-left">
                <Link class="btn btn-warning mb-2 mb-md-0 mr-2" to="/parametres/roles"><i class="mdi mdi-backburger"></i> Retour à la liste</Link>
                {/* <button class="btn btn-outline-primary mb-2 mb-md-0"> Import documents </button> */}
              </div>
              
            </div>

            <div class="col-12 grid-margin stretch-card">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">Nouveau rôle</h4>
                    <p class="card-description">Tous les champs sont obligatoires</p>
                    <form class="row" onSubmit={submitForm}>

                            <div class="col-lg-2 col-12"></div>
                            <div class="col-lg-8 col-12">
                                
                            <div class="card mb-4">
                                
                                <div class="card-body">
                                        
                                    
                                    <div>
                                        <div class="mb-3">
                                            <label class="form-label">Veuillez renseigner le rôle<span className="text-danger">*</span></label>
                                            <input className="form-control" onChange={(e)=>setRoleData(e.target.value)} required/>
                                        </div>

                                        <div class="mb-3">
                                        <div class="table-responsive">
                                            <DataTable 
                                                columns={columns} 
                                                data={permissions} 
                                                customStyles={customStyles}
                                                selectableRows
                                                onSelectedRowsChange={handleRowSelected}
                                                selectableRowsComponentProps={{ inkDisabled: true }}
                                            />
                                        </div>
                                        </div>
                                    </div>


                                </div>

                                
                                </div>
                                

                                

                                <div class="d-grid">
                                {!loading &&
                                    <button type="submit" class="btn btn-primary">
                                        Enregistrer
                                    </button>
                                }
                                {loading &&
                                <button class="btn btn-primary" type="button" disabled>
                                    <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                                    Enregistrement en cours...
                                </button>
                                }

                            </div>

                            </div>

                            </form>
                  </div>
                </div>
              </div>
            </ContentPage>
        </>
    )
}

export default AddRoleForm;